import { toast } from 'react-toastify';
import React from 'react';
import Toast from '../Toast';

export const successToast = (message) => {
  toast.success(
    <Toast
      icon="icon icon-success"
      title="Authentication error"
    >
      {message}
    </Toast>, {
      position: 'bottom-center',
      autoClose: 10000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    },
  );
};

export const errorToast = (message) => {
  toast.error(
    <Toast
      icon="icon icon-error"
      title="Authentication error"
    >
      {message}
    </Toast>, {
      position: 'bottom-center',
      autoClose: 10000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    },
  );
};
